<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.reagendamentoMedico"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="$router.push({name: 'regulacao-reagendamento-medico-edit', params: {id: item.id}})"
                authorize="edit-regulacao-reagendamento-medico"
                color="primary"
                small
                title="Reagendar consultas"
            >
                <rkm-icon icon="calendar-alt" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
import {repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            reagendamentoMedico: this.getConectaSusRepository('regulacao.reagendamentoMedico'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'cidadao.nome', searchable: true, sortable: true},
            {key: 'dataNascimento', label: 'Data de nascimento', name: 'cidadao.data_nascimento', searchable: true, sortable: true},
            {key: 'cpf', label: 'CPF', name: 'cidadao.cpf', searchable: true, sortable: true},
            {key: 'cns', label: 'CNS', name: 'cidadao.cns', searchable: true, sortable: true},
            {key: 'actions', label: 'Ações', class: 'col-min'},
        ],
    }),
    mixins: [repository],
}
</script>
